import JOB_OPENINGS from "@/resources/content/jobOpenings.json";

export const getJobOpenings = () => {
  return JOB_OPENINGS;
};
